import React, { useState, useEffect } from "react";
import { Col, Form, FormGroup, Input, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import animationData from "../assets/animation_llmdcvau.json";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { updatekycStatus } from "../Features/userSlice";
import Webcam from "react-webcam";

import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import app from "../firebase";
import axiosInstance from "../axiosInstance";
import { constants } from "../Utils/constants";


const ProfileVerifications = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);
  const [userVerificationDetails, setUserVerificationDetails] = useState({
    aadharNo: "",
    drivingNo: "",
    aadharImg: "",
    drivingImg: "",
    photo: "",
    // SelectedFiles: [],
  });

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setCam(!cam);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  //-------- uploading images-----------------------------
  const [kycStatus, setKycStatus] = useState(false);

  const [aadharImg, setAadharImg] = useState(undefined);
  const [drivingImg, setDrivingImg] = useState(undefined);
  const [photo, setPhoto] = useState(undefined);
  const [imgPerc, setImgPerc] = useState(0);

  const uploadFile = (file, urlType) => {
    const storage = getStorage(app);
    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, `user${currentUser.id}/` + fileName);
    // const metadata = {
    //contentType: 'image/jpeg',
    //};
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setImgPerc(Math.round(progress));
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
          default:
            break;
        }
      },
      (error) => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setUserVerificationDetails((prev) => {
            return { ...prev, [urlType]: downloadURL };
          });
        });
      }
    );
  };

  useEffect(() => {
    aadharImg && uploadFile(aadharImg, "aadharImg");
  }, [aadharImg]);

  useEffect(() => {
    drivingImg && uploadFile(drivingImg, "drivingImg");
  }, [drivingImg]);

  useEffect(() => {
    photo && uploadFile(photo, "photo");
  }, [photo]);

  //---------------------
  const [picture, setPicture] = useState("");
  const [cam, setCam] = useState(false);
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(() => {
    console.log("in cpature");
    const pictureSrc = webcamRef.current.getScreenshot();
    console.log(pictureSrc);
    console.log("-------------------------------------");
    const neww = pictureSrc.substring(23);
    console.log(neww);

    setPicture(neww);
  });

  const WebcamComponent = () => <Webcam />;

  const videoConstraints = {
    width: 350,
    height: 350,
    facingMode: "user",
  };

  const handleChange = (e) => {
    setUserVerificationDetails({
      ...userVerificationDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    if (userVerificationDetails.aadharNo.trim() === "") {
      toast.error("Adhaar No. Is Not Filled !!!", { theme: "colored" });
    } else if (!/^\d{12}$/.test(userVerificationDetails.aadharNo)) {
      toast.error("Adhaar No. Is Invalid (Require 12 Digit Adhaar No.) !!!", {
        theme: "colored",
      });
    } else if (userVerificationDetails.drivingNo.trim() === "") {
      toast.error("Driving Licence No. Is Not Filled !!!", {
        theme: "colored",
      });
    } else if (!/^[A-Z]{2}\d{13}$/.test(userVerificationDetails.drivingNo)) {
      toast.error(
        "Driving Licence No. Is Invalid (Require 15 Characters Valid DL No.) !!!",
        { theme: "colored" }
      );
    } else {
      const resp = await axiosInstance.post(constants.serverUrl+"/user/document", {
        ...userVerificationDetails,
        id: currentUser.id,
      });
      if (resp.data?.status == true) {
        dispatch(updatekycStatus());
        toast.success("Successful validation... ", {
          theme: "colored",
        });
      }

      //navigate("/profile/edit");
    }
  };

  return (
    <Col lg="7" md="7">
      {!currentUser.kycStatus ? (
        <>
          <Form method="post">
            <h4 className="fw-bold mb-4">Profile Verification</h4>
            <FormGroup className="contact__form">
              <Input
                name="aadharNo"
                id="adhaarNo"
                value={userVerificationDetails.aadharNo}
                onChange={handleChange}
                placeholder="Enter Adhaar No."
                type="text"
              />
            </FormGroup>
            <FormGroup className="contact__form">
              <Input
                name="drivingNo"
                id="DLNo"
                value={userVerificationDetails.drivingNo}
                onChange={handleChange}
                placeholder="Enter Driving Licence No."
                type="text"
              />
            </FormGroup>
            <FormGroup>
              <Label className="ms-1" for="adhaarUpload">
                Upload Adhaar Card
              </Label>
              {aadharImg != undefined ? (
                "Uploading:" + imgPerc + "%"
              ) : (
                <Input
                  type="file"
                  name="adhaarUploadImage"
                  id="adhaarUpload"
                  onChange={(e) => setAadharImg(e.target.files[0])}
                />
              )}
            </FormGroup>
            <img src={userVerificationDetails.aadharImg} height={60} />
            <FormGroup>
              <Label className="ms-1" for="drivingLicenceUpload">
                Upload Driving Licence
              </Label>
              {drivingImg != undefined ? (
                "Uploading:" + imgPerc + "%"
              ) : (
                <Input
                  type="file"
                  name="drivingLicenceImage"
                  id="drivingLicenceUpload"
                  onChange={(e) => setDrivingImg(e.target.files[0])}
                />
              )}
            </FormGroup>
            <img src={userVerificationDetails.drivingImg} height={60} />
            <FormGroup>
              <Label className="ms-1" for="photoUpload">
                Upload Passport-Size Photo
              </Label>
              {photo != undefined ? (
                "Uploading:" + imgPerc + "%"
              ) : (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Input
                    type="file"
                    name="photoUploadImage"
                    id="photoUpload"
                    onChange={(e) => setPhoto(e.target.files[0])}
                  />
                  <CameraAltIcon
                    fontSize="large"
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      handleOpen();
                      setCam(!cam);
                    }}
                  />
                </div>
              )}
            </FormGroup>
            <img src={userVerificationDetails.photo} height={60} />

            <div>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <div>
                    {cam && picture == "" ? (
                      <Webcam
                        audio={false}
                        //height={400}
                        ref={webcamRef}
                        //width={400}
                        screenshotFormat="image/jpeg"
                        videoConstraints={videoConstraints}
                      />
                    ) : (
                      <img src={picture} />
                    )}
                  </div>
                  <div>
                    {picture != "" ? (
                      <>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setPhoto(picture);
                            setOpen(false);
                          }}
                          className="btn btn-success me-3 mt-1"
                        >
                          OK
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setPicture("");
                          }}
                          className="btn btn-primary mt-1"
                        >
                          Retake
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          capture();
                        }}
                        className="btn btn-danger"
                      >
                        Capture
                      </button>
                    )}
                  </div>
                </Box>
              </Modal>
            </div>
          </Form>
          <div className="mt-5 text-center">
            <button
              className="contact__btn"
              type="button"
              onClick={handleSubmit}
            >
              Save Profile
            </button>
          </div>
        </>
      ) : (
        <>
          <h2>
            <span class="badge bg-primary">
              Your KYC has been successfully verified
            </span>
          </h2>
          <Lottie
            style={{ height: "50%", width: "50%", margin: "10%" }}
            animationData={animationData}
          />
        </>
      )}
    </Col>
  );
};
export default ProfileVerifications;
